import React from 'react'
import PropTypes from 'prop-types'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


const ProductGender = ({ sex }) => (
  <Box mt="4">
    <Text message={messages[sex]} size="14-24" color="gray" />
  </Box>
)

ProductGender.propTypes = {
  sex: PropTypes.string.isRequired,
}


export default React.memo(ProductGender)
